import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { backendApi } from "../../api/apiService.js";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; 

const Notification = ({ setTabIndex }) => {
  const [userList, setUserList] = useState([]);
  const [selectedTo, setSelectedTo] = useState([]);
  const [selectedCc, setSelectedCc] = useState([]);

  const userDetails = useSelector((state) => state.login.userDetails);
  const userData = useSelector((state) => state.login.userData);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      backgroundColor: state.isFocused ? '#e0f0ff' : provided.backgroundColor,
      color: '#333',
      cursor: 'pointer',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getUserList = async () => {
    const api = {
      functionName: "userListing",
      site_id: userDetails[0].site_id,
    };
    try {
      const response = await backendApi(api);
      console.log("User list API response:", response); // Debugging statement
      if (response.success === "1") {
        const usersList = response.dataSet.map((m) => ({
          label: `${m.first_name} ${m.last_name}`,
          value: m.email_id,
        }));
        setUserList(usersList);
        console.log("User list:", usersList); // Debugging statement
        await getSavedEmailReportMembers(usersList);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const handleSave = async () => {
    const toEmails = selectedTo.map((user) => user.value).join(",");
    const ccEmails = selectedCc.map((user) => user.value).join(",");
  
    const emailData = {
      functionName: "updateEmailMembers",
      site_id: userDetails[0].site_id,
      email_reports_to: toEmails,
      email_reports_cc: ccEmails,
    };
  
    try {
      const response = await backendApi(emailData);
      console.log("API Response:", response);
  
      if (response.success === "1") {
        toast.success(response.successMessage);
      } else {
        toast.warn(response.successMessage);
      }
    } catch (error) {
      console.error("Error saving email report configuration:", error);
      toast.error("An error occurred while saving!");
    }
  };
  

  const getSavedEmailReportMembers = async (usersList) => {
    const api = {
      functionName: "getEmailReportMembers",
      site_id: userDetails[0].site_id,
    };

    try {
      const response = await backendApi(api);
      console.log("Fetch saved email report members API response:", response); // Debugging statement
      if (response.success === "1") {
        const { email_reports_to, email_reports_cc } = response.dataSet;

        const toEmails = email_reports_to ? email_reports_to.split(",") : [];
        const ccEmails = email_reports_cc ? email_reports_cc.split(",") : [];

        const toSelected = usersList.filter(user => toEmails.includes(user.value));
        const ccSelected = usersList.filter(user => ccEmails.includes(user.value));

        setSelectedTo(toSelected);
        setSelectedCc(ccSelected);
      }
    } catch (error) {
      console.error("Error fetching saved email report members:", error);
    }
  };

  useEffect(() => {
    getUserList();
  }, [userDetails, userData]);
  
  return (
    <div className="col-md-12">
      <ToastContainer
        position="bottom-right"
        pauseOnHover
      />
      <br />
      <div className="form-group">
        <label><b>Email Report To:</b></label>
        <Select
          isMulti
          name="reportTo"
          placeholder="Select recipients"
          options={userList}
          value={selectedTo}
          onChange={setSelectedTo}
          className="basic-multi-select"
          classNamePrefix="select"
          styles={customStyles}
          menuPlacement="top"
        />
      </div>

      <div className="form-group">
        <label><b>Email Report CC:</b></label>
        <Select
          isMulti
          name="reportCc"
          placeholder="Select CC recipients"
          options={userList}
          value={selectedCc}
          onChange={setSelectedCc}
          className="basic-multi-select"
          classNamePrefix="select"
          styles={customStyles}
          menuPlacement="top"
        />
      </div>
      <button className="btn btn-primary" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default Notification;